import React from 'react';
import Card from '../common/Card';
import { theme } from '../../config/theme';
import { formatCurrency } from '../../utils/helpers';
import { PackageIcon, CheckCircleIcon, AlertIcon, XCircleIcon } from '../icons/Icons';

const ProductStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Products',
      value: stats?.total || 0,
      icon: <PackageIcon size={24} />,
      color: theme.colors.primary.main,
    },
    {
      label: 'Active Products',
      value: stats?.active || 0,
      icon: <CheckCircleIcon size={24} />,
      color: theme.colors.success,
    },
    {
      label: 'Low Stock',
      value: stats?.lowStock || 0,
      icon: <AlertIcon size={24} />,
      color: theme.colors.warning,
    },
    {
      label: 'Out of Stock',
      value: stats?.outOfStock || 0,
      icon: <XCircleIcon size={24} />,
      color: theme.colors.error,
    },
  ];

  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing.lg,
  };

  const statCardStyles = {
    padding: theme.spacing.lg,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.lg,
    border: `1px solid ${theme.colors.gray[200]}`,
  };

  const iconWrapperStyles = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: theme.borderRadius.md,
    backgroundColor: `${color}15`,
    color: color,
    marginBottom: theme.spacing.sm,
  });

  return (
    <div style={gridStyles}>
      {statCards.map((stat, index) => (
        <div key={index} style={statCardStyles}>
          <div style={iconWrapperStyles(stat.color)}>
            {stat.icon}
          </div>
          <div style={{ 
            fontSize: theme.typography.fontSize.sm, 
            color: theme.colors.text.secondary,
            marginBottom: theme.spacing.xs,
          }}>
            {stat.label}
          </div>
          <div style={{ 
            fontSize: theme.typography.fontSize['2xl'], 
            fontWeight: theme.typography.fontWeight.bold,
            color: stat.color,
          }}>
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductStats;